import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '../../../ui/Radio/RadioGroup';
import { TranslationKey } from '../../../i18n/translationKeys';
import type { TemplateLanguage } from '../../../types/customEmailTemplate';

interface CustomTemplateLanguageToggleProps {
    value: TemplateLanguage;
    languages: TemplateLanguage[];
    onChange: (language: TemplateLanguage) => void;
    disabled?: boolean;
}

const LANGUAGE_LABELS: Record<TemplateLanguage, string> = {
    FR: TranslationKey.CustomEmailTemplate.Languages.Fr,
    EN: TranslationKey.CustomEmailTemplate.Languages.En,
};

const LABEL_ID = 'email-custom-language-label';

// The language is a property of the email, not a tone: radios keep it distinct from the tone chips above.
export const CustomTemplateLanguageToggle: React.FC<CustomTemplateLanguageToggleProps> = ({ value, languages, onChange, disabled = false }) => {
    const { t } = useTranslation();

    return (
        <div role="radiogroup" aria-labelledby={LABEL_ID} className="flex flex-wrap items-center gap-m">
            <span id={LABEL_ID} className="text-compact text-primary-700">
                {t(TranslationKey.CustomerFollowUp.Email.CustomTemplate.LanguageLabel)}
            </span>
            <RadioGroup
                name="email-custom-language"
                value={value}
                disabled={disabled}
                onChange={language => { if (language !== value) onChange(language as TemplateLanguage); }}
                options={languages.map(language => ({
                    value: language,
                    label: t(LANGUAGE_LABELS[language]),
                    'data-testid': `email-custom-language-${language}`,
                }))}
            />
        </div>
    );
};
